import { toImageUrl } from '../utils/format.util';

export default class IndexService {
  constructor(firebase) {
    this.firebase = firebase;
  }

  async getIndex(collection, doc) {
    const indexDoc = await this.firebase.firestore()
      .collection(collection)
      .doc(doc)
      .get();

    const index = {
      ...indexDoc.data(),
      id: indexDoc.id,
      image: indexDoc.data() && indexDoc.data().keyCard && indexDoc.data().keyCard.id ? toImageUrl(`cards/thumb_${indexDoc.data().keyCard.id}`) : null,
      icon: indexDoc.data() && indexDoc.data().config && indexDoc.data().config.icon ? indexDoc.data().config.icon : 'assessment',
      description: indexDoc.data() && indexDoc.data().config && indexDoc.data().config.description ? indexDoc.data().config.description : null,
    };

    if (indexDoc.data() && indexDoc.data().date && typeof indexDoc.data().date.toDate === 'function') {
      index.date = indexDoc.data().date.toDate();
    }

    if (collection.includes('users/') && collection.includes('/customIndexes')) {
      index.icon = 'dashboard_customize';
      index.custom = true;
    }

    return index;
  }

  async getIndexSnapshot() {
    const indexSnapshotDoc = await this.firebase.firestore()
      .collection('config')
      .doc('indexSnapshot')
      .get();

    return indexSnapshotDoc.data();
  }

  async getDashboard() {
    const doc = await this.firebase.firestore()
      .collection('config')
      .doc('dashboard')
      .get();

    const dashboard = {
      id: doc.id,
      ...doc.data(),
      date: doc.data().date ? doc.data().date.toDate() : doc.data().date.toDate(),
      mostRecentUpdate: {
        ...doc.data().mostRecentUpdate,
        date: doc.data().mostRecentUpdate.date ? doc.data().mostRecentUpdate.date.toDate() : doc.data().mostRecentUpdate.date.toDate(),
      },
    };

    return dashboard;
  }

  async getIndustry() {
    const doc = await this.firebase.firestore()
      .collection('config')
      .doc('industry')
      .get();

    const industry = {
      id: doc.id,
      ...doc.data(),
    };

    return industry;
  }

  async getReport() {
    const doc = await this.firebase.firestore()
      .collection('config')
      .doc('reports')
      .get();

    const report = {
      id: doc.id,
      ...doc.data(),
    };

    return report;
  }
}
